import { parseAbi } from "viem";

/** Minimal ERC-721 surface for approvals + stake path. */
export const erc721Abi = parseAbi([
  "function approve(address to, uint256 tokenId) external",
  "function setApprovalForAll(address operator, bool approved) external",
  "function getApproved(uint256 tokenId) view returns (address)",
  "function isApprovedForAll(address owner, address operator) view returns (bool)",
]);

/** Reads only — for `multicall` (no events). */
export const stakingReadAbi = parseAbi([
  "function activeInfo(uint256 tokenId) view returns (address activator, uint64 activatedAt, uint64 lastClaimAt, bool active)",
  "function pendingXp(uint256 tokenId) view returns (uint256)",
  "function EARN_INTERVAL() view returns (uint256)",
  "function XP_PER_INTERVAL() view returns (uint256)",
]);

export const stakingAbi = parseAbi([
  "function activate(uint256 tokenId) external",
  "function activateBatch(uint256[] tokenIds) external",
  "function deactivate(uint256 tokenId) external",
  "function deactivateBatch(uint256[] tokenIds) external",
  "function claim(uint256 tokenId) external",
  "function claimBatch(uint256[] tokenIds) external",
  "function paused() view returns (bool)",
  "function activeInfo(uint256 tokenId) view returns (address activator, uint64 activatedAt, uint64 lastClaimAt, bool active)",
  "function pendingXp(uint256 tokenId) view returns (uint256)",
  "function EARN_INTERVAL() view returns (uint256)",
  "function XP_PER_INTERVAL() view returns (uint256)",
  "function owlexNft() view returns (address)",
  "function xp() view returns (address)",
  "event Activated(address indexed user, uint256 indexed tokenId, uint64 activatedAt)",
  "event Deactivated(address indexed user, uint256 indexed tokenId)",
  "event Claimed(address indexed user, uint256 indexed tokenId, uint256 xpMinted)",
]);

export const erc20Abi = parseAbi([
  "function balanceOf(address account) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) external returns (bool)",
  "function transfer(address to, uint256 amount) external returns (bool)",
]);

/** OwlexTraitSpinUpgradeable — reads + writes (XP-only spins). */
export const traitSpinReadAbi = parseAbi([
  "function xpSpinCost() view returns (uint256)",
]);

export const traitSpinAbi = parseAbi([
  "function requestSpin(uint256 traitTypeId, uint256 layerIndex)",
  "function requestSpinBatch(uint256[] traitTypeIds, uint256[] layerIndices)",
  "function quoteBatchSpin(uint256[] traitTypeIds, uint256[] layerIndices) view returns (uint256 totalXp)",
  "function revealSpin()",
  "function paused() view returns (bool)",
  "function xpSpinCost() view returns (uint256)",
  "function spinLayerCount(uint256 traitTypeId) view returns (uint256)",
  "function traitPoolLength(uint256 traitTypeId, uint256 layerIndex) view returns (uint256)",
  "function pendingQueueLen(address user) view returns (uint256)",
  "function pendingQueueItem(address user, uint256 index) view returns (uint256, uint256, uint256, uint256)",
  "function outfitTraitTypeId() view returns (uint256)",
  "function traitTypeCount() view returns (uint256)",
  "function traitTypeName(uint256 traitTypeId) view returns (string)",
  "function traitAt(uint256 traitTypeId, uint256 layerIndex, uint256 poolIndex) view returns (string)",
  "function spinLayerName(uint256 traitTypeId, uint256 layerIndex) view returns (string)",
  "function layerCloudflareId(uint256 traitTypeId, uint256 layerIndex) view returns (string)",
  "function unboundTraitCount(address user) view returns (uint256)",
  "function unboundTraitAt(address user, uint256 index) view returns (bytes32)",
  "function equipTrait(uint256 tokenId, uint256 traitTypeId, uint256 layerIndex, string traitName) external",
  "function unequipTrait(uint256 tokenId, uint256 traitTypeId) external",
  "function equippedTrait(uint256 tokenId, uint256 traitTypeId) view returns (bytes32)",
  "function ownsTrait(address user, bytes32 traitId) view returns (bool)",
]);
